import { useState } from "react";
import { obtenerDatosTemporisApi } from "../../api/listas/temporisApi";
import { useUnidadRolTemporis } from "../../hooks/datosLaborales";
import { getNumerosEnCadena_2 } from "../../utils/funciones";
import { mensajeSimple } from "../../components/ui/sweetAlerts";

export const useCambioUnidad = () => {
  const [arrTemporis, setArrTemporis] = useState([]);
  const [arrPlanHorario, setArrPlanHorario] = useState([]);

  const { setRolTemporis } = useUnidadRolTemporis();

  const setTemporis = async (obj) => {
    if (!obj) return;

    setRolTemporis("cod_sap_nuevo_cargo");
    let numero_plan_horario = "";
    let local_codigo_erp = "";

    if (typeof obj === "object") {
      numero_plan_horario = getNumerosEnCadena_2(obj["REEO_PLAN_HORARIO"]);
      local_codigo_erp = obj["REEO_COD_SUB_DIVISION"];
    }

    const obj_ = (typeof obj === "string") ? JSON.parse(obj) : '';

    if (obj_) {
      numero_plan_horario = getNumerosEnCadena_2(obj_["MOES_DESCRIPCION_POSICION"]);
      local_codigo_erp = obj_["MOES_COD_SUB_DIVISION"];
    }

    const temporis = await obtenerDatosTemporisApi(local_codigo_erp, numero_plan_horario);
    setArrPlanHorario(temporis.data);

    if (temporis.data.length === 0) {
      mensajeSimple("info", "No se encontraron planes de horario para este cargo", 3000);
      return;
    }

    const arr = temporis.unidad_organizativa_rol_temporis.map((el) => {

      return {
        label: `${el.Unidadorganizativa} - ${el.Cargogenericonombre}`,
        value: el,
      };
    });

    setArrTemporis(arr);
  }

  return {
    setTemporis, arrTemporis, arrPlanHorario
  }
}